import React, { useState, useEffect } from "react";
import FiltroCursoPerfil from "../InfoCursos/components/FiltroCursoPerfil/FiltroCursoPerfil";
import PerfilCursos from "../InfoCursos/components/PerfilCursos";
import ModalDetalleCurso from "../InfoCursos/components/ModalDetalleCurso";
import { Oval } from "react-loader-spinner";
import { useGlobalContext } from "../../../../../../context/GlobalContext";

export default function DatosUsuario({ homeContainerRef }) {
  const { perfil, errorPerfil,loadingPerfil} = useGlobalContext();
  const [showModal, setShowModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("TODOS");
  

  // Se recibe el id del curso clickeado y se muestra el modal
  const handleCardClick = (courseId) => {
    setSelectedCourseId(courseId);
    setShowModal(true);
  };

  // Función para cerrar el modal y limpiar el id seleccionado
  const handleCloseModal = () => {
    setShowModal(false);
  };


  // Mientras se cargan los datos o hay errorPerfil, se muestra un mensaje
  if (loadingPerfil) {
    return (
      <Oval
        visible={true}
        height="50"
        width="50"
        color="#fff"
        secondaryColor="#f5f5f5"
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    );
  }

  if (errorPerfil) {
    return <p>Error: {errorPerfil}</p>;
  }

  // Verifica que perfil ya esté definido antes de acceder a sus propiedades
  if (!perfil) {
    return <p>No hay datos disponibles del perfil.</p>;
  }

  return (
    <div data-figma-id="1620:14275" className="perfil-info-1">
      <div data-figma-id="1620:14276" className="perfil-info-1-contenido">
        <div data-figma-id="1620:14277" className="perfil-info-1-perfil">
          <div data-figma-id="1620:14278" className="perfil-info-1-perfil-1">
            <div data-figma-id="1620:14279" className="perfil-icono-grande">
              <p
                data-figma-id="1620:14280"
                className="perfil-icono-grande-texto"
              >
                {perfil.datos.informacion_del_usuario.iniciales}
              </p>
            </div>
            <div
              data-figma-id="1620:14281"
              className="perfil-info-1-perfil-1-nombre"
            >
              <p data-figma-id="1620:14282" className="perfil-nombre-texto">
                {perfil.datos.informacion_del_usuario.nombre_completo}
              </p>
              <p data-figma-id="1620:14283" className="perfil-id-texto">
                ID: {perfil.datos.informacion_del_usuario.id_empleado}
              </p>
            </div>
          </div>
          <div data-figma-id="1620:14284" className="perfil-info-1-perfil-2">
            <p
              data-figma-id="1620:14285"
              className="perfil-info-1-perfil-2-info-texto-1"
            >
              Información del usuario
            </p>
            <div data-figma-id="1620:14286" className="perfil-puesto">
              <div data-figma-id="1620:14287" className="perfil-puesto-info-1">
                <i class="fi fi-ts-briefcase-blank briefcase-1-2"></i>
                <p
                  data-figma-id="1620:14289"
                  className="perfil-puesto-info-1-texto"
                >
                  Puesto:
                </p>
              </div>
              <p data-figma-id="1620:14290" className="perfil-puesto-texto">
                {perfil.datos.informacion_del_usuario.alumno_puesto}
              </p>
            </div>
            <div data-figma-id="1620:14291" className="perfil-empresa">
              <div data-figma-id="1620:14292" className="perfil-empresa-info-1">
                <i class="fi fi-ts-corporate-alt corporate-alt-2"></i>

                <p
                  data-figma-id="1620:14294"
                  className="perfil-empresa-info-1-texto"
                >
                  Empresa:
                </p>
              </div>
              <p data-figma-id="1620:14295" className="perfil-empresa-texto">
                {perfil.datos.informacion_del_usuario.nombre_organizacion}
              </p>
            </div>
            <p
              data-figma-id="1620:14296"
              className="perfil-info-1-perfil-2-info-estudiante"
            >
              Estudiante desde:{" "}
              {perfil.datos.informacion_del_usuario.fecha_creacion}
            </p>
          </div>
        </div>
        <div class="linea-miscursos-h"></div>
        <div data-figma-id="1620:14298" className="perfil-info-2-perfil">
          <p data-figma-id="1620:14299" className="perfil-info-2-perfil-texto">
            Tu progreso
          </p>
          <div data-figma-id="1620:14300" className="perfil-lecciones">
            <i class="fi fi-tr-book-alt libro-alternativo-4"></i>
            <p data-figma-id="1620:14302" className="perfil-lecciones-texto">
              {perfil.datos.tu_progreso.total_lecciones_completadas} lecciones
              completadas
            </p>
          </div>
          <div data-figma-id="1620:14303" className="perfil-horas-aprendizaje">
            <i class="fi fi-tr-clock-five reloj-cinco-2"></i>
            <p
              data-figma-id="1620:14305"
              className="perfil-horas-aprendizaje-texto"
            >
              {perfil.datos.tu_progreso.total_horas_estudiadas} horas de
              aprendizaje
            </p>
          </div>
          {/* Sección de progreso de cursos 
          <div data-figma-id="1620:14306" className="perfil-tests">
            <i class="fi fi-ts-completed terms-check-2"></i>
            <p data-figma-id="1620:14308" className="perfil-tests-texto">
              {perfil.datos.tu_progreso.total_lecciones_completadas} tests
              completados
            </p>
          </div>
            */}
        </div>
      </div>
      <div data-figma-id="1620:14310" className="perfil-info-2-mobile">
        <p data-figma-id="1620:14311" className="info-1-curso-titulo-2-2">Cursos</p>
        <FiltroCursoPerfil
          filterText={filterText}
          setFilterText={setFilterText}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          onFilterClick={() => setShowModal(false)}
        />
        <div data-figma-id="1620:14319" className="frame-290159">
          {showModal ? (
            <ModalDetalleCurso
              onClose={handleCloseModal}
              courseId={selectedCourseId}
              homeContainerRef={homeContainerRef}
            />
          ) : (
            <PerfilCursos
              onCardClick={handleCardClick}
              filterText={filterText}
              selectedCategory={selectedCategory}
            />
          )}
        </div>
      </div>
    </div>
  );
}
